import { useContext } from "react";
import { JourneysContext } from "../../context/journeys-context";
import { PageHeader, Loading, Icon } from "@evertrue/et-components";
import { PropTypes } from "base/react-libs";
import JourneysTaskDueDate from "./journeys-task-due-date";
import JourneysTitleList from "./top-nav/journeys-title-list";
import JourneysDashboard from "./journeys-dashboard";
import JourneyPauseContainer from "./journeys-pause-container";
import JourneyTableTaskCount from "./journeys-table-task-count";
import EmptyStateMessage from "components/lists/empty-state-message";
import EverTrue from "app";

const JourneysMainContent = ({ setShowSettings }) => {
  const { loadingJourneys, renderEmptyState, onStageWithTable } = useContext(JourneysContext);

  return (
    <>
      <div className="title-container">
        <Icon
          icon="chevron-left"
          size={2}
          className="settings-back"
          onClick={() => {
            EverTrue.UrlManager.navigate("/home", true, false);
          }}
        />
        <PageHeader title="Cadences" className="journeys-title" />
      </div>
      {loadingJourneys ? (
        <div style={{ position: "relative", height: "75vh" }}>
          <Loading position={"center"} />
        </div>
      ) : renderEmptyState ? (
        <EmptyStateMessage icon="ban" text={"The stage group you have selected is not affiliated with any cadences"} />
      ) : (
        <>
          <JourneyPauseContainer setShowSettings={setShowSettings} />
          <div className="journeys-header">
            <JourneysTaskDueDate />
            {!onStageWithTable && <JourneyTableTaskCount />}
            <JourneysTitleList />
          </div>
          <JourneysDashboard />
          <div className="journeys-settings-container">
            <Icon icon="gear" size={1} onClick={() => setShowSettings(true)} className="journeys-settings-icon" />
          </div>
        </>
      )}
    </>
  );
};

JourneysMainContent.propTypes = {
  setShowSettings: PropTypes.func,
};

export default JourneysMainContent;
